import { CommonModule } from "@angular/common";
import { Component, inject, Input } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap/modal";
import { PreisEintrag } from "../../Api/DcoApi/Admin/AdminClasses";
import { AdminCard } from "../Controlls/Sonstige/AdminCard";

@Component({
  selector: 'PreisHist',
  standalone: true,
  imports: [CommonModule, FormsModule, AdminCard],
  templateUrl: './PreisHist.html',
  styleUrl: './PreisHist.css'
})

export class PreisHist {
  @Input() header: string = '';
  @Input() labelText: string = '';
  @Input() Items: PreisEintrag[] = [];

  modal = inject(NgbActiveModal);
}
